import React, { PropsWithChildren } from 'react';
import { useObserverReturningStore } from '../../../CodesThatsGottaGoSomewhereElse';
import { Rect } from '../../../platform/geom/Rect';
import { useResolve } from '../../Container';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { Camera } from '../Camera';
import { Physical, RelativeTo } from '../entities/Physical';
import { useComponentObserver } from './ComponentObserver';

export const AttachPhysical = ({ object, children }: PropsWithChildren<{ object: Physical }>) => {
    useComponentObserver(object);
    const camera = useObserverReturningStore(useResolve(Camera));
    const bounds = Rect.fromPoints(camera.toView(object.bounds(RelativeTo.Model)));

    const style = {
        ...bounds.toCSS(),
    };

    return <Flexer absolute {...{ style }}>
        {children}
    </Flexer>;
};
